import React, {FC} from 'react';
import Dashboard from '../components/Dashboard';
import { Config } from '../use-config/models/Config';
import VMConfiguration from '../components/VMConfiguration';

interface MainProps {
    config: Config
}

const Main: FC<MainProps> = props => {
    return <Dashboard config={props.config}>
        <VMConfiguration />
    </Dashboard>
}

export default Main

